import {enableProdMode, importProvidersFrom} from '@angular/core';
import {environment} from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app.component";
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {KeyDateService} from 'app/service/key-date.service';
import {BaseTranslateLoader, BasicVsciModule} from '@visana-web/basic-ui';
import {TranslateLoader, TranslateService} from '@ngx-translate/core';

export class CustomLoader extends BaseTranslateLoader {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.translateUrl = '/webresources/imprestAccount/r4/textModules';
  }
}

export function createTranslateLoader(httpClient: HttpClient): TranslateLoader {
  return new CustomLoader(httpClient);
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter([]), // Add your routes here
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      FormsModule,
      InfiniteScrollModule,
      BasicVsciModule.forRoot(),
      BasicVsciModule.forTranslationRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
          useClass: CustomLoader
        }
      })
    ),
    CookieService,
    TranslateService,
    KeyDateService,
    {provide: 'googleTagManagerId', useValue: 'GTM-N2GVGVSR'}
  ]
}).catch(e => console.error(e));
